"use client";

import { Check, Plus } from "lucide-react";
import { useUi } from "@/components/ui/use-ui";
import type { ProfileRef } from "@/lib/api/types";
import { cn } from "@/lib/cn";
import { useFollow } from "@/lib/library";
import { fmt } from "@/lib/locales/fmt";

export function FollowButton({ profile, size = 38 }: { profile: ProfileRef; size?: number }) {
  const [following, toggle] = useFollow(profile);
  const t = useUi().actions;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={following}
      aria-label={fmt(following ? t.unfollowName : t.followName, { name: profile.name })}
      title={following ? t.following : t.follow}
      className={cn(
        "grid shrink-0 place-items-center rounded-full transition-colors",
        following ? "bg-white/15 text-fg hover:bg-white/25" : "bg-white text-black hover:bg-white/85",
      )}
      style={{ width: size, height: size }}
    >
      {following ? <Check size={size * 0.5} strokeWidth={2} /> : <Plus size={size * 0.55} strokeWidth={1.6} />}
    </button>
  );
}
